import { computed, observable } from "mobx";
import FormStore from "~/stores/FormStore";
import ProviderStore from "~/stores/Provider/ProviderStore";
import CreditPurchaseStore from "~/stores/Credit/CreditPurchaseStore";
import ProductStore from "~/stores/ProductStore";
import TaxStore from "~/stores/Invoice/TaxStore";
import CreditCardStore from "~/stores/Credit/CreditCardStore";
import CreditHelper from "~/utils/CreditHelper";
import i18n from "~/components/i18n";

class PurchaseCreditFormStore {
  @observable providerStore = null;

  @observable publishTourProductStore = null;

  @observable taxStore = null;

  @observable creditCardStore = null;

  @observable formStore = null;

  constructor() {
    this.providerStore = new ProviderStore();
    this.providerStore.isLoading = true;
    this.creditPurchaseStore = new CreditPurchaseStore();
    this.publishTourProductStore = new ProductStore();
    this.taxStore = new TaxStore();
    this.creditCardStore = new CreditCardStore();
    this.formStore = new FormStore();
  }

  @computed
  get orderQuantityOptions() {
    const { product } = this.publishTourProductStore;

    if (!product) {
      return [];
    }

    const { discountedCreditCost } = product;

    return CreditHelper.getCreditOptions(
      discountedCreditCost,
      [1, 1.2, 2, 3, 4, 5, 10, 15, 20, 25, 50, 100, 250, 500],
      i18n.t("billingCentral:selectAQuantityPlaceholder"),
      true,
    );
  }

  @computed
  get creditCardId() {
    const { model } = this.formStore;

    return model.creditCardId !== "" ? parseInt(model.creditCardId, 10) : null;
  }

  @computed
  get orderCreditQuantity() {
    const { model } = this.formStore;

    return model.orderCreditQuantity !== "" ? parseInt(model.orderCreditQuantity, 10) : 0;
  }

  @computed
  get costPerCredit() {
    const { provider } = this.providerStore;

    return provider.discountQuantity > 0 && this.orderCreditQuantity >= provider.discountQuantity
      ? provider.discountCreditCost
      : provider.standardCost;
  }

  @computed
  get subtotal() {
    return this.orderCreditQuantity * this.costPerCredit;
  }

  @computed
  get totalCost() {
    const { taxes: applicableTaxes } = this.taxStore;

    if (applicableTaxes.length === 0) {
      return this.subtotal;
    }

    let taxAmount = 0;

    applicableTaxes.forEach(applicableTax => {
      taxAmount += Math.round(this.subtotal * applicableTax.rate) / 100;
    });

    return this.subtotal + taxAmount;
  }

  @computed
  get creditCardOptions() {
    const { creditCards } = this.creditCardStore;
    const creditCardOptions = [{ key: "noValue", value: "", text: `(${i18n.t("none")})` }];

    creditCards.forEach(creditCard => {
      creditCardOptions.push({
        key: creditCard.creditCardId,
        value: creditCard.creditCardId,
        text: `${creditCard.cardName} ${creditCard.maskedCardNumber}`,
      });
    });

    return creditCardOptions;
  }
}

export default PurchaseCreditFormStore;
